import React from "react";
import { EduMainBox } from "./styles";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { ReachStep } from "./Steps/ReachStep/reachStep";
import AuthModals from "../Common/AuthModals/authModals";
import { ExperienceStep } from "./Steps/ExperienceStep/experienceStep";
import { CreateAccountStep } from "./Steps/CreateAccountStep/createAccountStep";
import { EducatorProfileStep } from "./Steps/EducatorProfileStep/educatorProfileStep";

const EducatorAccountMainPage = () => {
  const location = useLocation();
  const urlInfoObj = location.state || {}
  const lastPageRoute = location.state?.from
  const steps = useSelector((state) => state.educatorSteps.steps)
  const chooseModal = useSelector((state) => state.auth.chooseModal);
  const userData = useSelector((state) => state.userData.data);
  return (
    <>
      <AuthModals chooseModal={chooseModal} />
      <EduMainBox>
        {steps === 1 && <CreateAccountStep lastPageRoute={lastPageRoute} urlInfoObj={urlInfoObj} />}
        {(!userData?.educator?.onboarding_complete && userData?.is_educator) && (
          <>
            {steps === 2 && <ExperienceStep lastPageRoute={lastPageRoute} urlInfoObj={urlInfoObj} />}
            {steps === 3 && <ReachStep lastPageRoute={lastPageRoute} urlInfoObj={urlInfoObj} />}
            {steps === 4 && <EducatorProfileStep lastPageRoute={lastPageRoute} urlInfoObj={urlInfoObj} />}
          </>
        )}
      </EduMainBox>
    </>
  );
};
export default EducatorAccountMainPage;
